import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        resetScrollPosition();
    }, [pathname]);

    return null;
}

export default ScrollToTop;

export const scrollToTopFunction = () => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0; // Safari 호환
    document.documentElement.scrollTop = 0; // 기타 브라우저

    // 내부 스크롤 컨테이너 처리
    const scrollContainers = document.querySelectorAll('.scrollable, [style*="overflow: auto"], [style*="overflow-y: auto"]');
    scrollContainers.forEach((container) => {
        if (container instanceof HTMLElement) {
            container.scrollTop = 0;
        }
    });

    // 약간 지연 후 다시 스크롤 처리 (렌더링 완료 후)
    const timeoutId = setTimeout(() => {
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0;
    }, 100);

    return () => clearTimeout(timeoutId);
};

// IOS에서 스크롤 위치 복원 문제 해결
export const resetScrollPosition = () => {
    // 다양한 방법으로 스크롤 초기화 시도
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    // InnerLayout 스크롤 리셋
    const innerLayout = document.querySelector('.mindup-layout');
    if (innerLayout) {
        innerLayout.scrollTop = 0;
    }

    // iOS 주소창 처리를 위한 추가 조치
    setTimeout(() => {
        window.scrollTo(0, 1);
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 50);
    }, 50);
};
